import { Component } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { MerchItemDetailsComponent } from '../merch-item-details/merch-item-details.component';
import { FormControl } from '@angular/forms';
import { isNgTemplate } from '@angular/compiler';

@Component({
  selector: 'app-merch-listing',
  templateUrl: './merch-listing.component.html',
  styleUrls: ['./merch-listing.component.scss']
})
export class MerchListingComponent {
  constructor(
    private http: HttpClient,
		// @Inject('$rootScope') private $rootScope: any,
    public dialog: MatDialog,
  ) {
    this.http.get<any>(environment.apiSrc + '/merch/all').subscribe( data => { 

      data.forEach(a => { 
        a.inStock = a.params.some(b => b.inventory > 0 )
      });

      this.allMerch = data.sort((a,b) => String(b.type).localeCompare(String(a.type)) || b.id - a.id ) ;

      this.catList = [...new Set(this.allMerch.map(i => i.type))];
      

      this.filter();

    });

    this.inStock.valueChanges.subscribe(changes => {
      console.log(changes);
      this.filter();
    });

    this.visibility.valueChanges.subscribe(changes => {
      console.log(changes);
      this.filter();
    });

    this.categories.valueChanges.subscribe(changes => {
      console.log(changes);
      this.filter();
    })
  }

  allMerch: any[] = [];
  filteredMerch: any[] = [];

  catList: any[] = [];

  inStock = new FormControl("any");

  visibility = new FormControl("all");

  categories = new FormControl([ "tshirt", "tote", "sticker", "socks", "pins-patches", "hat", "general", "coasters-coolers" ]);
  
  filter() {
    this.filteredMerch = this.allMerch.filter( 
      i => this.categories.value?.includes(i.type) 
        && ( this.visibility.value === 'all' || i.public === (this.visibility.value === 'public') ) && ( this.inStock.value === 'any' || (this.inStock.value === 'available' && i.inStock ) || (this.inStock.value === 'unavailable' && !i.inStock)  ) 
    );
  }
  editItem(item, event) {
    event.stopPropagation();
    console.log(item);
    this.dialog.open(MerchItemDetailsComponent, {
      data: { ...item }, 
      width: '80vw',
      maxHeight: '90vh'
    });
  }

  addItem() {
    this.dialog.open(MerchItemDetailsComponent, {
      data: {}, 
      width: '80vw',
      maxHeight: '90vh',
    });
  }

}
